module.exports = __webpack_public_path__ + "img/mobile-spectrum-ProjectSpectrum2.ba2132ac.png";